import React, { useEffect, useState } from 'react';
import ObjectExploder from '@app/components/ObjectExploder/objectExploder.component';
import i18n from '@app/helpers/i18n';
import { ILogsFlattened } from '@app/models';

interface IReceivedData {
    raw: ILogsFlattened;
}

export const RawEventComponent = (props: IReceivedData) => {
    const [json, setJson] = useState('');
    const [raw, setRaw] = useState();

    const [titles, setTitles] = useState<{event: string, audit: string}>({event: '', audit: ''});

    useEffect(() => {
        const jsonString: string = JSON.stringify(props.raw, null, 2);
        setJson(jsonString);
        setTitles({
            event: i18n.t('RAW_EVENT_LOG'),
            audit: i18n.t('RAW_AUDIT_RECORD')
        });
    }, []);

    useEffect(() => {
        if (json !== '') {
            let x = json.replace(/record_identity_/g, '');
            x = x.replace(/record_/g, '');
            x = x.replace(/trace_clientIp_organization_/g, '');
            x = x.replace(/trace_clientIp_/g, '');
            x = x.replace(/trace_/g, '');

            setRaw(JSON.parse(x));
        }
    }, [json]);

    return (
        <>
            <div className='log__detail'>
                <div className='log__scrollable--section'>
                    <h2>{titles.event}</h2>
                    <ObjectExploder prefix='AUDIT_LOG_NAME' item={raw} key={Math.floor(Math.random() * 1000)} />
                    <h2>{titles.audit}</h2>
                    <div className='log__raw-record'>
                        <pre>
                            <code>{json}</code>
                        </pre>
                    </div>
                 </div>
            </div>
        </>
    );
};
